/**
 * TrafficControlPage — one nav entry for "change live traffic in the proxy".
 *
 * IU Rewrite (point ad units at test units) and Chaos (delay / block / mock)
 * are both rule tables the proxy applies to traffic in flight, and both are
 * Wi-Fi-proxy only — USB/logcat traffic never passes through them. They render
 * unchanged as tabs here; /rewrite and /chaos redirect to their tab.
 */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IuRewritePage from './IuRewritePage';
import ChaosPage from './ChaosPage';

export const TRAFFIC_TABS = ['rewrite', 'chaos'];

const TAB_LABELS = { rewrite: 'IU Rewrite', chaos: 'Chaos (delay / block / mock)' };

/** tabFromSearch(search) — the ?tab= deep link, or 'rewrite' when absent/unknown. */
export function tabFromSearch(search) {
  try {
    const t = new URLSearchParams(search || '').get('tab');
    return TRAFFIC_TABS.includes(t) ? t : 'rewrite';
  } catch { return 'rewrite'; }
}

export default function TrafficControlPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [tab, setTab] = useState(() => tabFromSearch(location.search));

  useEffect(() => {
    if (new URLSearchParams(location.search).has('tab')) setTab(tabFromSearch(location.search));
  }, [location.search]);

  function changeTab(next) {
    setTab(next);
    navigate(`/traffic?tab=${next}`, { replace: true });
  }

  return (
    <Box>
      <Box sx={{ maxWidth: 980, mx: 'auto', px: 2, pt: 2 }}>
        <Tabs value={tab} onChange={(e, v) => changeTab(v)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
          {TRAFFIC_TABS.map((t) => <Tab key={t} value={t} label={TAB_LABELS[t]} />)}
        </Tabs>
      </Box>
      {tab === 'rewrite' ? <IuRewritePage /> : <ChaosPage />}
    </Box>
  );
}
